// Simple functional component that adds space between other elements
function Spacer(props) {
  return (
    <div style={{height: props.height}}></div>
  )
}

export default Spacer;
